/**
 * @module 同居家族変更ダイアログコンポーネント
 */
import { relationship } from '../../computed';

export default {
  name: 'EditFamilyModal',
  props: [
    'person',
    'error',
    'valid',
    'dialog',
    'appendAlertClass',
    'toggleModal',
    'relationship',
    'copyPerson',
    'sortFlag',
  ],
  data(vm) {
    return {
      childDialog: this.dialog,
      childPerson: { ...this.person },
      childValid: this.valid,
      dateMenu: false,
      displayDialog: false,
      childCopyPerson: this.copyPerson,
      rules: {
        // 氏名
        name: [
          // 必須チェック
          (value) =>
            !!value ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0006'
            ),
        ],
        // 氏名（カナ）
        nameKana: [
          // 必須チェック
          (value) =>
            !!value ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0008'
            ),
          // 全角カナチェック
          (value) =>
            (!!value && /^[ァ-ヶー]+$/.test(value)) ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0010'
            ),
        ],
        // 続柄
        relationship: [
          // 必須チェック
          (value) => {
            if (value === '' || value === null || value === undefined) {
              return vm.$vuetify.lang.t(
                '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0011'
              );
            } else {
              return true;
            }
          },
        ],
        // 続柄（その他）
        relationshipOther: [
          // 必須チェック
          (value) => {
            if ((value === '' || value === null) && this.childPerson.relationship === 99) {
              return vm.$vuetify.lang.t(
                '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0012'
              );
            } else {
              return true;
            }
          },
        ],
        // 生年月日
        birthday: [
          // 必須チェック
          (value) =>
            !!value ||
            vm.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU43緊急連絡先設定画面同居家族情報.E0014'
            ),
        ],
      },
    };
  },
  watch: {
    'childPerson.relationship'(val) {
      if (val === 99) {
        this.$nextTick(
          () => this.$refs.relationshipOtherText.focus() || this.$refs.relationshipSelect.blur()
        );
      } else {
        this.childPerson.relationshipOther = '';
      }
    },
    childDialog(isOpened) {
      if (!isOpened) {
        this.closeModal();
      }
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * キャンセルボタン押下時処理
     */
    closeModal() {
      this.childDialog = false;
      setTimeout(() => {
        this.displayDialog = false;
      }, 200);
      this.childPerson = { ...this.childCopyPerson };
    },
    /**
     * ダイアログ表示処理
     */
    openModal() {
      this.displayDialog = true;
    },
    /**
     * 生年月日フォーマット処理
     * @param {Date} date 生年月日
     * @returns 生年月日(YY/mm/dd)
     */
    formatDate(date) {
      if (!date) {
        return '';
      }
      const year = date.substr(0, 4);
      const month = date.substr(5, 2);
      const day = date.substr(8, 2);
      return year + '/' + month + '/' + day;
    },
    /**
     * 登録ボタン押下時処理
     */
    submit() {
      if (this.$refs.form.validate()) {
        this.editPerson();
      }
    },
    /**
     * 登録ボタン押下時処理呼び出し処理
     */
    editPerson() {
      this.$emit('edit-person', { ...this.childPerson });
      this.closeModal();
      this.childDialog = false;
    },
  },
  computed: {
    disabled() {
      return !this.childValid;
    },
    dateShow: {
      get() {
        return this.formatDate(this.childPerson.birthday);
      },
    },
    i18nItems(vm) {
      return {
        relationshipList: relationship(vm),
      };
    },
    today() {
      return new Date()
        .toLocaleDateString('ja-JP', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
        .split('/')
        .join('-');
    },
  },
};
